module.exports = __webpack_public_path__ + "img/RECREATION_YOURFEELING.c58cd3c4.png";